import React from 'react';
import {TextField as TextFieldMUI, TextFieldProps} from '@mui/material';
import {FieldAttributes, FieldInputProps} from 'formik';
import {NumericFormat} from 'react-number-format';
import {FieldValue} from '../AutoForm/AutoFieldNew';
import {useAutoForm} from '../AutoForm/useAutoForm';
import {UPDATES} from '../../shared/UPDATES';

export type SpecialCharacterProps = {
  specialSymbol: string;
  decimalPlaces: number;
  position: 'start' | 'end';
  index?: number;
  readOnly?: boolean;
  freeTyping: boolean;
};

type Props = TextFieldProps &
  FieldInputProps<string> &
  SpecialCharacterProps &
  FieldAttributes<any>;

const SpecialCharacterTextField: React.FC<Props> = (props) => {
  const {
    specialSymbol,
    position,
    decimalPlaces = 0,
    index = 0,
    inputProps,
    onChange,
    freeTyping = false,
    ...otherProps
  } = props;
  const formik = useAutoForm<Record<string, FieldValue>>();

  return (
    <>
      <NumericFormat
        id={`${props.id}${index}`}
        label={props.label}
        value={props.value}
        allowLeadingZeros={false}
        prefix={props.position === 'start' ? props.specialSymbol : ''}
        suffix={props.position === 'end' ? props.specialSymbol : ''}
        thousandSeparator=","
        decimalScale={props.decimalPlaces ?? 2}
        fixedDecimalScale
        disabled={props.disabled}
        readOnly={props.readOnly}
        customInput={TextFieldMUI}
        sx={{
          '& input': {
            padding: '8.5px 14px',
            textAlign: 'end',
            '&[type=number]': {
              MozAppearance: 'textfield',
            },
            '&::-webkit-outer-spin-button': {
              WebkitAppearance: 'none',
              margin: 0,
            },
            '&::-webkit-inner-spin-button': {
              WebkitAppearance: 'none',
              margin: 0,
            },
          },
        }}
        onValueChange={(values, sourceInfo) => {
          if (!props.onChange) {
            return;
          }
          formik.setFieldValue(
            UPDATES._4700,
            props.field.name,
            String(values.floatValue)
          );
        }}
        {...otherProps}
      />
    </>
  );
};

export const MoneyField: React.FC<Props> = (props) => (
  <SpecialCharacterTextField
    {...props}
    specialSymbol="£"
    position="start"
    decimalPlaces={props.decimalPlaces ?? 2}
  />
);

export const PercentField: React.FC<Props> = (props) => (
  <SpecialCharacterTextField
    {...props}
    specialSymbol="%"
    position="end"
    decimalPlaces={props.decimalPlaces ?? 1}
  />
);
